// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file asset/v1/asset.proto (package asset.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Interval } from "../../base/v1/interval_pb.js";

/**
 * @generated from enum asset.v1.AssetCategory
 */
export const AssetCategory = /*@__PURE__*/ proto3.makeEnum(
  "asset.v1.AssetCategory",
  [
    {no: 0, name: "ASSET_CATEGORY_INVALID", localName: "INVALID"},
    {no: 1, name: "ASSET_CATEGORY_NONE", localName: "NONE"},
    {no: 2, name: "ASSET_CATEGORY_MOST_CRITICAL", localName: "MOST_CRITICAL"},
    {no: 3, name: "ASSET_CATEGORY_CRITICAL", localName: "CRITICAL"},
    {no: 4, name: "ASSET_CATEGORY_MILD", localName: "MILD"},
  ],
);

/**
 * @generated from message asset.v1.AssetContact
 */
export const AssetContact = /*@__PURE__*/ proto3.makeMessageType(
  "asset.v1.AssetContact",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "emails", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "phone_numbers", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message asset.v1.Asset
 */
export const Asset = /*@__PURE__*/ proto3.makeMessageType(
  "asset.v1.Asset",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sr_no", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "category", kind: "enum", T: proto3.getEnumType(AssetCategory) },
    { no: 5, name: "vendor_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "vendor_contacts", kind: "message", T: AssetContact, repeated: true },
    { no: 7, name: "amcs", kind: "message", T: AMC, repeated: true },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
    { no: 9, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message asset.v1.AMCPayment
 */
export const AMCPayment = /*@__PURE__*/ proto3.makeMessageType(
  "asset.v1.AMCPayment",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "paid_on", kind: "message", T: Timestamp },
    { no: 3, name: "is_partial", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message asset.v1.AMC
 */
export const AMC = /*@__PURE__*/ proto3.makeMessageType(
  "asset.v1.AMC",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "contacts", kind: "message", T: AssetContact, repeated: true },
    { no: 3, name: "duration", kind: "message", T: Interval },
    { no: 4, name: "due_date", kind: "message", T: Timestamp },
    { no: 5, name: "cost", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "comments", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "payments", kind: "message", T: AMCPayment, repeated: true },
    { no: 8, name: "last_paid_amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "is_current", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

